// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("trix")
require("@rails/actiontext")
require("@rails/activestorage").start()
require("channels")
require('datatables.net-bs4')
require('datatables.net-responsive-bs4')
require('bootstrap-datepicker');
require('nanoscroller');


//require("bootstrap")

import "./main"


// Stylesheets
require("../stylesheets/main.scss")
require("../stylesheets/theme.css")


import "bootstrap";
import "../stylesheets/application.scss";

document.addEventListener("turbolinks:load", () => {
    console.log('turbolinks is loaded....')
    $('.datepicker').datepicker({
        format: 'dd.mm.yyyy'
    });
    let context = $('#context').attr('data-context');
    console.log('datatable context is: ' + context);

    const dTable = $('.bootstraped-table').DataTable({
        sDom: '<"row view-filter"<"col-sm-12"<"pull-left"l><"pull-right"f><"clearfix">>>t<"row view-pager"<"col-sm-12"<"text-center"ip>>>',
        responsive: true,
        autoWidth: true,
        ajax: resolveDatatablesLink(context),
        processing: true,
        serverSide: true,
        pageLength: 20,
        dom: 'Bfrtip',
        buttons: [
            'excelHtml5',
            'pdfHtml5',
            'print',
            'colvis'
        ]
    });

    dTable.columns().every(function (col) {
        console.log("col in dcolumns every is: " + col);
        var that = this;
        var columnSelector = findColumnSelector(col);
        console.log('Column selector is: ' + columnSelector);
        if (columnSelector !== '.filter-false') {
            $(columnSelector).on('change', function () {
                console.log("some column has changed...")
                if (that.search() !== this.value) {
                    console.log('this value in that search: ' + this.value)
                    that.search(this.value).draw();
                }
            });
        }
    });

    function findColumnSelector(index) {
        let filterHeaders = '#'
        filterHeaders += context
        filterHeaders += '-table tr th'
        console.log('filter headers are: ' + filterHeaders)
        return '.filter-' + $(filterHeaders).eq(index).data('filter');
    };

    $('#patients-table_filter').hide();
    $('#visits-table_filter').hide();

    $('.pagination').css('float', 'right')

    $('.toggle-display-div').on('click', function(){
        let clicked = $(this).attr('data-section');
        console.log('data-displayed is: ' + $(this).attr('data-displayed'))
        let currentState = ($(this).attr('data-displayed') == 'true');
        let newDisplayedState = !currentState
        $(this).attr('data-displayed', newDisplayedState.toString());
        toggleDiv(clicked, currentState)
    })

    $('.search-patient').on('click', function(){
        let firstName = $('#first-name').val();
        let lastName = $('#last-name').val();
        console.log('search firstname: ' + firstName)
        console.log('search lastname: ' + lastName)
        $.ajax({
            method: 'GET',
            url: '/search_patient',
            data: { first_name: firstName, last_name: lastName},
            success: function(data){
                console.log(data);
                $('#search-patient-body').html(data);
            }
        })
    })

    $('body').on('click', '.mark-visit-paid', function(){
        const visitId = $(this).attr('data-visit-id');
        console.log('mark paid: ' + visitId)
        const confirmed = confirm('Jeni i sigurte?');
        if(confirmed){
            markVisitPaid(visitId)
        } else {
            console.log('its not confirmed')
        }
    })

    $('body').on('click', '.fa-eur', function(){
        let paymentDiv = $(this).closest('.process-payment');
        paymentDiv.find('.paid-sum').attr('disabled', false);
        paymentDiv.find('i').removeClass('fa-eur');
        paymentDiv.find('i').addClass('fa-save')
        paymentDiv.find('i').addClass('confirm-payment');
        paymentDiv.find('.paid-sum').css('background-color', 'white')
    })

    $('body').on('click', '.confirm-payment', function(){
        let paymentDiv = $(this).closest('.process-payment');
        let visitId = paymentDiv.attr('data-visit-id');
        console.log('visitId: ' + visitId);
        let value = paymentDiv.find('.paid-sum').val();
        submitPayment(visitId, value)
    })
})

function submitPayment(visitId, value){
    console.log('visit : ' +  visitId + ' value: ' + value);
    $.ajax({
        method: 'get',
        url: '/submit_payment',
        data: { visit_id: visitId, value: value},
        success: function(data){
            alert('Pagesa eshte perditesuar!')
        }
    })
}

function toggleDiv(section, state){
    let existingState = state;
    let sectionId = '#' + section;
    let newDisplayState = false;
    console.log('existingState is: ' + existingState)
    if(existingState == true){
        newDisplayState = 'none';
    } else {
        newDisplayState = 'flex';
    }
    let newState = !existingState;
    console.log('newState is: ' + newState);
    console.log('newDisplayState is: ' + newDisplayState);
    $(sectionId).css('display', newDisplayState);
}

function resolveDatatablesLink(context){
    let ajaxUrl = ''
    if (context == 'patients'){
        ajaxUrl = '/patients_datatable'
    } else if (context == 'visits') {
        ajaxUrl = '/visits_datatable'
    } else if (context == 'days-visits') {
        ajaxUrl = '/days_visits_datatable'
    } else if (context == 'glasses') {
        ajaxUrl = '/glasses_datatable'
    }

    console.log('ajaxUrl is: ' + ajaxUrl);
    return ajaxUrl;
}



// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
